<script>
import { notificationMethods } from '@/state/helpers'
import appConfig from '@/app.config'

export default {
  name: 'app',
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification()
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
  },
}
</script>

<template>
  <div id="app">
    <RouterView :key="$route.path" />
  </div>
</template>

<style>
p {
  margin: 0px;
  padding: 0px;
}
</style>
